import { Injectable } from '@angular/core';
import { Store } from '../../core/services/store.service';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * A store storing the url.
 */
@Injectable({
  providedIn: 'root',
})
export class UrlStoreService extends Store<string> {

  constructor(private router: Router, private route: ActivatedRoute) {
    super(null, 'storedUrl');
  }

  public navigate(value?: string) {
    if (this.state !== null) {
      let url = this.state;
      this.setState(null);
      this.router.navigateByUrl(url);
    } else {
      if (value) {
        this.router.navigateByUrl(value);
      } else {
        this.router.navigate(['../'], { relativeTo: this.route });

      }
    }
  }

  public setState(nextState: string): void {
    super.setState(nextState);
  }

  public get state() {
    return super.state;
  }

}
